export { default } from './request-equipment-service-body';
